<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p2ESpL/tc-custom/cover.jpg?1684988687141?1692044807271" alt="This image is the cover for the book Tertium Non Data"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tertium Non Data
      </h1>
      <p class="bookDescription body article font2">
        <p>When Lord Louis Hector married his wife Beatrice, she was an invalid and he only had the clothing on his back. Now they are the lead investors of Rolls Royce and have two wonderful small children, Abigail and Eleanor. By all appearances, they are a perfect couple, but Lord Hector also has a softer side, one which his wife may not fully comprehend. He loves poetry, Shakespeare, and the often repeated phrase of Latin alchemical wisdom, <i>tertium non data</i> . He longs to find out how base metals turn into gold, and he sees an opportunity to explore this when he meets William Bailey.<br/><br/>Captivated by William's plight for independence and his love of a good story, Lord Hector sees past William's legacy as the son of a thief and offers him a new chance at life. William is relieved by the lord’s sudden trust, but still struggles against other's perceptions of him as the manor’s new footman. When he hears the maids say the word "invert" about one of the lord's young daughters, he is compelled to close the gap in his knowledge and better himself.<br/><br/>He seeks out the lord's large book collection to help him with this quest. He vows to practice speaking aloud more so he can recite poetry and not worry about mispronouncing the words -- or letting Lord Hector down. As Lord Hector polishes away the rough spots in William’s character, both men soon discover nothing in their lives will be the same again.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francis Gideon
      </h2>
      
      <p class="authorDescription body article">Francis Gideon is a writer of m/m romance, but has also dabbled in mystery, historical, fantasy, sci-fi, and paranormal fiction. For more information, visit francisgideon.wordpress.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?484b00b1